import { JSONSchemaType } from 'ajv'

export interface IRecipeExecutionLogFormData {
  id: string
  recipeId: string
  executionDateTimeStart: string
  executionDateTimeEnd: string
  executionFinalStatus: string
  executionOutput: string
  billingReference: string
  billingAmount: number
  billingDetail: string
}

const RecipeExecutionLogSchema: JSONSchemaType<IRecipeExecutionLogFormData> = {
  type: 'object',
  properties: {
    recipeId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    executionDateTimeStart: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    executionDateTimeEnd: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    id: {
      type: 'string',
    },
    executionOutput: {
      type: 'string',
    },
    executionFinalStatus: {
      type: 'string',
    },
    billingReference: {
      type: 'string',
    },
    billingAmount: {
      type: 'number',
    },
    billingDetail: {
      type: 'string',
    },
  },
  required: ['recipeId', 'executionDateTimeStart', 'executionDateTimeEnd'],
  additionalProperties: false,
}

export default RecipeExecutionLogSchema
